import axios from "axios";
import api from "@/app/lib/axios";

import { ExchangeDirection, ExchangeResult, ExchangeStatus } from "@/types/exchange";

export async function getExchangeStatus(): Promise<ExchangeStatus> {
    try {
        const { data } = await api.get<ExchangeStatus>("exchange/status");
        return data;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            throw new Error(err.response?.data?.error ?? err.response?.data?.message ?? "Failed to load exchange status");
        }
        throw err;
    }
}

export async function performExchange(direction: ExchangeDirection, amount: number): Promise<ExchangeResult> {
    try {
        const { data } = await api.post<ExchangeResult>("exchange", { direction, amount });
        return data;
    } catch (err) {
        if (axios.isAxiosError(err)) {
            const responseData = err.response?.data;
            const validationErrors = responseData?.errors
                ? Object.values(responseData.errors).flat().join(' ')
                : undefined;
            throw new Error(responseData?.error ?? validationErrors ?? responseData?.message ?? "Exchange failed");
        }
        throw err;
    }
}
